import axios from 'axios';

export const api = axios.create({
  baseURL: import.meta.env.VITE_STREAMETRIC_API,
  // timeout: 10000,
  withCredentials: true,
});
